import React from 'react';
import { Parallax } from 'react-scroll-parallax';
import styles from './background.module.scss';
import BackgroundModel from '../../../models/background';
import ImageWrapper from '../imageWrapper/imageWrapper';
import FullScreenMedia from '../../full-screen-media/FullScreenMedia';

const NonVideoBackground = ({ messageScrollSpeed, images, message }: any) => (
  <>
    {message && (
      <Parallax
        horizontal
        speed={messageScrollSpeed}
        data-rellax-vertical-scroll-axis="x"
        className={styles.background__scrolling}
      >
        <span className={styles.background__scrollingText}>{message}</span>
      </Parallax>
    )}
    {images?.map((image: any) => (
      <ImageWrapper key={image.image?.alt} {...image} />
    ))}
  </>
);

export default ({
  video,
  images,
  message,
  backgroundColor,
  messageScrollSpeed
}: BackgroundModel) => {
  return (
    <div className={styles.background} style={{ background: backgroundColor }}>
      {video ? (
        <FullScreenMedia data={video} anchorSide="right" />
      ) : (
        <NonVideoBackground
          images={images}
          message={message}
          messageScrollSpeed={messageScrollSpeed}
        />
      )}
    </div>
  );
};
